<style src="./ModalDetails.scss" lang="scss"></style>
<template>
  <div class="modal inmodal in" tabindex="-1" :style="display" v-if="show">
    <div class="modal-dialog ModalSerproDetails">
      <div class="modal-content animated fadeIn">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            @click="closeModal"
          >
            <span aria-hidden="true">&times;</span>
            <span class="sr-only">
              Close
            </span>
          </button>
          <h4 class="modal-title">Autorizar Notificação</h4>
          <h2 class="modal-title licencePlateTitle">{{ item.licencePlate.toUpperCase() }}</h2>
        </div>

        <ModalContent :item="item" v-model="form"/>
        <ModalCommands
          ref="modalCommands"
          @send-to-serpro="sendToSerpro"
          @refuse="refuse" />
      </div>
    </div>
  </div>
</template>

<script>
import ModalCommands from '../modal-commands/ModalCommands.vue';
import ModalContent from '../modal-content/ModalContent.vue';
import { toast } from '@/plugins/toast';

export default {
  components: {
    ModalCommands,
    ModalContent,
  },
  props: {
    item: {
      default: () => ({})
    },
    show: {
      default: false,
    },
    count: {
      default: 0,
    },
    currentItem: {
      default: 0,
    }
  },
  data() {
    return {
      form: {},
      invalidReason: '',
      validState: 0
    };
  },
  computed: {
    display() {
      return this.show ? 'display: block' : 'display: none';
    },
  },
  methods: {
    closeModal() {
      this.$emit('close-modal', { forceRefresh: true });
    },
    async confirmAction() {
      this.$emit('confirm');
    },
    refuseValidation() {},
    cancelValidation() {
      this.validState = 0;
    },
    setValidState(state) {
      this.validState = state;
    },
    confirmValidation() {
      this.validState = 0;
    },
    closeAndRefresh() {
      this.$emit('close-modal', { forceRefresh: true });
    },
    async sendToSerpro() {
      // Send to Serpro
      const payload = {
        licencePlate: this.item.licencePlate,
        ...this.form,
        creditId: this.item._id,
        toasted: toast
      }
      this.$emit('sendToSerpro', payload)

      this.$refs.modalCommands.enableCommands();
      this.$emit('goNext');
      if (this.currentItem + 1 === this.count) {
        this.closeAndRefresh();
        return;
      }
    },
    async refuse(observation) {
      const payload = {
        licencePlate: this.item.licencePlate,
        toasted: toast,
        observation,
        creditId: this.item._id
      }
      this.$emit('refuse', payload)
      this.$refs.modalCommands.enableCommands();
      this.$emit('goNext');
      if (this.currentItem + 1 === this.count) {
        this.closeAndRefresh();
        return;
      }
    }
  }
};
</script>
